import { put, takeEvery, call } from "redux-saga/effects";
// import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import * as actionTypes from "./constants";
import endpoints from "../endpoints";
// import api from "../api";
import fmApi from "../APIWrapper";
import { formatDate, formatBytes } from "../../screens/Common/customUtils";
import XLSX from "xlsx";

// function* commonFunction(value) {
//   const token = localStorage.getItem("fmsToken");
//   try {
//     const res = yield fetch(`${value.api}`, {
//       method: `${value.method}`,
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//         type: "Web",
//       },
//       body: value.body ? value.body : null,
//     });
//     if (!res.ok) {
//       throw res;
//     } else {
//       const resJSON = yield res.json();

//       yield put({
//         type: `${value.sucessAction}`,
//         payload: resJSON,
//       });
//       yield put({ type: `${value.initAction}`, value: value.initPayload });

//       yield toast.success(value.toastMsg, {
//         autoClose: 3000,
//       });
//       return resJSON;
//     }
//   } catch (err) {
//     if (err.ok === false) {
//       yield put({ type: `${value.failAction}`, error: err });
//     } else {
//     }
//   }
// }

const columnHeaders = [
  "Apartment No",
  "Location",
  "Alert Type",
  "Date",
  "Time",
  "Flow Quantity",
  "Flow Duration",
];

const tableData = (data) => {
  return data?.map((item) => {
    return {
      "Apartment No": item?.aptNo || "",
      Location: item?.location || "",
      "Alert Type": item?.alertType === "Q" ? "Burst" : "Leakage" || "-",
      Date: formatDate(item?.date) || "",
      Time: item?.time || "",
      "Flow Quantity": item?.quantity || "",
      "Flow Duration": item?.duration || "",
    };
  });
};

function* fetchCurrentAlert() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
    type: "current",
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/identityservice/society/alert`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_CURRENT_ALERT_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_CURRENT_ALERT_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonFunction, params);

    // return Res;
    const resJSON = yield call(fmApi.FetchCurrentAlertApi, data);

    yield put({
      type: actionTypes.FETCH_CURRENT_ALERT_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_CURRENT_ALERT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}
function* fetchAlertHistory(value) {
  let page = value.value.page;
  let aptNumber = value.value.aptNumber;
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
    type: "history",
    limit: 50,
    page: page || value.value,
    aptNumber: aptNumber || "",
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/identityservice/society/alert`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_ALERT_HISTORY_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_ALERT_HISTORY_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonFunction, params);

    // return Res;
    const resJSON = yield call(fmApi.FetchAlertHistoryApi, data);

    yield put({
      type: actionTypes.FETCH_ALERT_HISTORY_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_ALERT_HISTORY_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* alertValveAction(value) {
  const Username = JSON.parse(localStorage.getItem("FmsUser")).username;
  // const token = localStorage.getItem("fmsToken");
  const data = {
    meterId: value?.value?.meterId,
    action: value.value.value,
    username: Username,
    adminFlag: true,
    userInterface: "admin",
    actionReason: "admin",
  };
  try {
    // const res = yield fetch(
    //   `${appConfig.urlPrefixIp}/apartmentinfoservice/society/valve`,
    //   {
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //       type: "Web",
    //     },
    //     body: JSON.stringify(data),
    //   }
    // );
    // if (!res.ok) {
    //   let errJSON = {};
    //   try {
    //     errJSON = yield res.json();
    //   } catch {}
    //   throw Object.assign(res, errJSON);
    // } else {
    //   const resJSON = yield res.json();
    const resJSON = yield call(fmApi.PostAlertValveActionApi, data);
    yield put({
      type: actionTypes.POST_CURRENT_ALERT_ACTION_SUCCESS_ACTION,
      payload: resJSON,
    });
    yield toast.success(
      "Action to " + value.value.value + " valve has been sent",
      {
        autoClose: 3000,
      },
    );
    yield put({
      type: actionTypes.FETCH_CURRENT_ALERT_INIT_ACTION,
    });
    // }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.POST_CURRENT_ALERT_ACTION_FAIL_ACTION,
        error: err,
      });
      yield toast.error(
        "Action to " + value.value.value + " valve has failed",
        {
          autoClose: 3000,
        },
      );
      if (err.status === 400) {
        yield toast.error(`${endpoints.status400}`, {
          autoClose: 3000,
        });
      } else if (err.status === 500) {
        yield toast.error(`${endpoints.status500}`, {
          autoClose: 3000,
        });
      } else {
      }
    }
  }
}

function* fetchSupportAddApartment() {
  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    societyId: societyId,
  };
  try {
    // let params = {
    //   api: `${appConfig.urlPrefixIp}/apartmentinfoservice/society/getapartmenttype`,
    //   method: "POST",
    //   sucessAction: actionTypes.FETCH_APT_SUCCESS_ACTION,
    //   failAction: actionTypes.FETCH_APT_FAIL_ACTION,
    //   body: JSON.stringify(data),
    // };
    // const Res = yield call(api.commonFunction, params);

    // return Res;
    const resJSON = yield call(fmApi.FetchApartmentTypeApi, data);

    yield put({
      type: actionTypes.FETCH_APT_SUCCESS_ACTION,
      payload: resJSON,
    });
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_APT_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

function* fetchDownloadAlertHistory(value) {
  const { aptId, fromDate, toDate, fileName, type } = value.value;

  const dayStartUTC = Math.floor(Date.parse(`${fromDate}T00:00:00Z`) / 1000);
  const dayEndUTC = Math.floor(Date.parse(`${toDate}T23:59:59Z`) / 1000);

  const societyId = JSON.parse(localStorage.getItem("FmsUser")).society_id;
  const data = {
    property: societyId,
    unitName: aptId || "",
    timeFrom: dayStartUTC,
    timeTo: dayEndUTC,
  };
  try {
    const resJSON = yield call(fmApi.FetchDownloadAlertHistoryApi, data);

    yield put({
      type: actionTypes.FETCH_DOWNLOAD_ALERT_HISTORY_SUCCESS_ACTION,
      payload: resJSON,
    });

    let resData = [...resJSON?.data];

    resData.sort((a, b) => {
      const alphaA = a.aptNo.replace(/[^a-zA-Z]/g, "");
      const alphaB = b.aptNo.replace(/[^a-zA-Z]/g, "");
      return alphaA.localeCompare(alphaB);
    });
    const mappedData = tableData(resData);

    if (type === "xlsx") {
      const worksheet = XLSX.utils.json_to_sheet(mappedData, {
        header: columnHeaders,
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Consolidated Data");
      const filename = fileName || `Alert History.xlsx`;
      XLSX.writeFile(workbook, filename);
      const xlsxBlob = new Blob([workbook], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const calculatedSize = xlsxBlob.size;
      const formattedFileSize = formatBytes(calculatedSize);
      const xlsxFileSizeElement = document.getElementById("xlsx-file-size");
      if (xlsxFileSizeElement) {
        xlsxFileSizeElement.textContent = formattedFileSize;
      }
    } else {
      const csvContent = `${columnHeaders
        .map((header) => `"${header}"`)
        .join(",")}\n${mappedData
        .map((item) =>
          columnHeaders.map((header) => `"${item[header]}"`).join(","),
        )
        .join("\n")}`;
      const encodedUri = encodeURI(`data:text/csv;charset=utf-8,${csvContent}`);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", fileName || `Alert History.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // const calculatedSize = new Blob([csvContent]).size;
      // setCsvFileSize(calculatedSize);
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: actionTypes.FETCH_DOWNLOAD_ALERT_HISTORY_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* AlertsBActionWatcher() {
  yield takeEvery(
    actionTypes.FETCH_CURRENT_ALERT_INIT_ACTION,
    fetchCurrentAlert,
  );
  yield takeEvery(
    actionTypes.FETCH_ALERT_HISTORY_INIT_ACTION,
    fetchAlertHistory,
  );
  yield takeEvery(
    actionTypes.POST_CURRENT_ALERT_ACTION_INIT_ACTION,
    alertValveAction,
  );
  yield takeEvery(actionTypes.FETCH_APT_INIT_ACTION, fetchSupportAddApartment);
  yield takeEvery(
    actionTypes.FETCH_DOWNLOAD_ALERT_HISTORY_INIT_ACTION,
    fetchDownloadAlertHistory,
  );
}
